<div class="main-wrapper d-flex align-items-center justify-content-center">
  <button mat-flat-button class="lang-btn" (click)="changeLanguage()">
    {{ 'general.language' | translate }}
  </button>
  <div class="card">
    <router-outlet></router-outlet>
  </div>
</div>
